import { render, staticRenderFns } from "./SpinningCoin.vue?vue&type=template&id=66f214cc&scoped=true&"
import script from "./SpinningCoin.vue?vue&type=script&lang=ts&"
export * from "./SpinningCoin.vue?vue&type=script&lang=ts&"
import style0 from "./SpinningCoin.vue?vue&type=style&index=0&id=66f214cc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f214cc",
  null
  
)

export default component.exports